import api from "../../../../../api/api"


const getByTransferId = (transferId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/inventory-transfer-item/"+transferId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) => {
    return new Promise((resolve, reject) => {
        api.post("erp/inventory-transfer-item", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const remove = (id) => {
    return new Promise((resolve, reject) => {
        api.delete("erp/inventory-transfer-item/" + id).then((res) => {
            if (!res.data.error) {
                resolve(res);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const inventoryTransferItemServices = {
    getByTransferId,
    save,
    remove,
};

export default inventoryTransferItemServices;